import { createContext } from 'react';
export const AppGlobalContext = createContext({});
export const AppGlobalUpdateContext = createContext(null);
